import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=1aba4612&"
import script from "./Profile.js?vue&type=script&lang=js&"
export * from "./Profile.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports